import { render, staticRenderFns } from "./AddAutoPurchaseTemplate.vue?vue&type=template&id=674a1a8e&scoped=true&"
import script from "./AddAutoPurchaseTemplate.vue?vue&type=script&lang=js&"
export * from "./AddAutoPurchaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddAutoPurchaseTemplate.vue?vue&type=style&index=0&id=674a1a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a1a8e",
  null
  
)

export default component.exports